import { call, put, select } from 'redux-saga/effects';
import { updatePermanentResidence as updatePermanentResidenceAda } from '@bitComponents/adabyron/client';
import { WEB_SERVICES } from './webServices';

const contextStore = state => state.context.data;

export function* updatePermanentResidence(params) {
  const {
    reduxUpdate,
    normalizeHttpErrors,
    permanentResidenceId,
  } = params;
  try {
    const { successUpdate } = reduxUpdate;
    const context = yield select(contextStore);
    const args = { permanentResidenceId };
    const response = yield call(updatePermanentResidenceAda, args, context);
    yield put(successUpdate(response));

    return response;
  } catch (error) {
    const { errorUpdate } = reduxUpdate;
    const errorNormalized = yield call(normalizeHttpErrors, WEB_SERVICES.UPDATE_PERMANENT_RESIDENCE, error);
    if (errorUpdate) {
      yield put(errorUpdate(errorNormalized));
    }

    throw error;
  }
}
